export type SortDirection = 'asc' | 'desc';
export type SortValue = string | number | Date | boolean | null | undefined;

const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

function isEmpty(v: SortValue): boolean {
  return v === null || v === undefined || v === '' || (v instanceof Date && Number.isNaN(v.getTime()));
}

function compare(a: SortValue, b: SortValue): number {
  if (typeof a === 'string' && typeof b === 'string') return collator.compare(a, b);
  const na = a instanceof Date ? a.getTime() : Number(a);
  const nb = b instanceof Date ? b.getTime() : Number(b);
  return na - nb;
}

/** Stable sort; empty values (null/undefined/''/invalid date) always last. */
export function sortRows<T>(
  rows: readonly T[],
  accessor: (row: T) => SortValue,
  direction: SortDirection,
): T[] {
  const sign = direction === 'asc' ? 1 : -1;
  return rows
    .map((row, index) => ({ row, index, value: accessor(row) }))
    .sort((x, y) => {
      const ex = isEmpty(x.value);
      const ey = isEmpty(y.value);
      if (ex || ey) return ex === ey ? x.index - y.index : ex ? 1 : -1;
      return sign * compare(x.value, y.value) || x.index - y.index;
    })
    .map((e) => e.row);
}
